export * from './FoodDrinkAlcoGlassWineIcon';
export * from './FoodDrinkAlcoGlassWineIcon16Light';
export * from './FoodDrinkAlcoGlassWineIcon16Regular';
export * from './FoodDrinkAlcoGlassWineIcon16Solid';
export * from './FoodDrinkAlcoGlassWineIcon20Light';
export * from './FoodDrinkAlcoGlassWineIcon20Regular';
export * from './FoodDrinkAlcoGlassWineIcon20Solid';
export * from './FoodDrinkAlcoGlassWineIcon24Regular';
export * from './FoodDrinkAlcoGlassWineIcon24Solid';
export * from './FoodDrinkAlcoGlassWineIcon32Regular';
export * from './FoodDrinkAlcoGlassWineIcon64Regular';
